module.exports = __webpack_public_path__ + "img/insights_icon.e87173c6.svg";